import { useApi, useCurrentUser } from 'lib/contexts/ApplicationState';
import { useSignUpModal } from 'components/SignUpModal';
import { BulkSavePostsToProjectsModal } from 'components/SaveToList/BulkSavePostsToProjectsModal';
import { useModal } from 'mui-modal-provider';
import { trackClickSignupEvent } from 'lib/hooks/useEventTracking';

interface Props {
  postId: number;
  text?: string;
  styling?: string;
}

export const SavePostToProjectsButton = ({
  postId, text, styling,
}: Props) => {
  const currentUser = useCurrentUser();
  const API = useApi();
  const { showSignUpModal } = useSignUpModal();
  const { showModal } = useModal();

  const click = () => {
    if (!currentUser) {
      trackClickSignupEvent(API, 'save-post-to-projects');
      showSignUpModal('Please sign up or sign in to save posts to projects');
      return;
    }
    const modal = showModal(BulkSavePostsToProjectsModal, {
      postIds: [postId],
      onClose: () => {
        modal.destroy();
      },
    });
  };

  return (
    <div className="object-cover w-full">
      <button
        type="button"
        onClick={click}
        className={styling || 'hover:bg-hintgray hover:dark:bg-darkgray/50 rounded-full w-full text-left'}
      >
        {text || 'Add post to project'}
      </button>
    </div>
  );
};
